module.exports = __webpack_public_path__ + "img/today.535783ed.png";